import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dwmdashbord-count-pop-up',
  templateUrl: './dwmdashbord-count-pop-up.component.html',
  styleUrls: ['./dwmdashbord-count-pop-up.component.scss'],
})
export class DwmdashbordCountPopUpComponent  implements OnInit {
  popupName: any;
  totalCount: any = 0;
  loggedInUserCompanyID: any;
  employeeId: any;
  startDate: any;
  endDate: any;
  skipedData: any[] = [];
  dwmRevied: any[] = [];
  dwmToBeRevied: any[] = [];
  months:any[] = [];
  calendarData:any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public sharedService: SharedService,
  public dialogRef: MatDialogRef<DwmdashbordCountPopUpComponent>, private dialog: MatDialog, private loadingService: LoaderService,
  private config: Config, private httpService: HttpService, private datePipe: DatePipe) {
    console.log(data)
    this.popupName = this.data?.popupName;
    this.loggedInUserCompanyID = this.data?.loggedInUserCompanyID;
    this.employeeId = this.data?.employeeId;
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.totalCount = this.data?.totalCount;
   }

  ngOnInit() {
    this.popupName = this.data?.popupName;
    if(this.popupName == 'No. of Days Skipped'){
      this.getSkippedDays();
    }
    if(this.popupName == 'Days of DWM Reviewed'){
      this.getSkippedDays();
      setTimeout(() =>{
        this.getDWMReviewed();
      },
      2000);
    }
    if(this.popupName == 'DWM to be reviewed'){
      this.getDWMToBeReviewed();
    }
  }
  getSelectedMonth(){
    this.months = [];
    let monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June','July', 'August', 'September', 'October', 'November', 'December'];
    let fromDate = new Date(new Date(this.startDate).getFullYear(), new Date(this.startDate).getMonth());
    let toDate = new Date(new Date(this.endDate).getFullYear(), new Date(this.endDate).getMonth() +1);
    while(fromDate < toDate){
      this.months.push({
        month: monthNames[fromDate.getMonth()],
        year: fromDate.getFullYear()
      });
      fromDate.setMonth(fromDate.getMonth() + 1);
    }
    console.log("months",this.months);
    this.calendarData = this.months.map(({ month, year }) => ({
      month,
      year,
      days: this.getDaysInMonth(year, monthNames.indexOf(month)),
      startDay: new Date(year, monthNames.indexOf(month), 1).getDay()
    }));
    console.log("calenderDate",this.calendarData)
  }
  getDaysInMonth(year: number, month: number) {
    const days:any[] = [];
    const date = new Date(year, month, 1);
    while (date.getMonth() === month) {
      const dateValue = new Date(date);
      const fromDate = new Date(this.startDate);
      const todate = new Date(this.endDate);
      todate.setHours(0, 0, 0, 0);
      fromDate.setHours(0, 0, 0, 0);
      dateValue.setHours(0, 0, 0, 0);

      let comment = null;
      let highlighted = (dateValue.getTime() >= fromDate.getTime() && dateValue.getTime() <= todate.getTime());
      let date1:any = this.datePipe.transform(new Date(date),"yyyy-MM-dd")
      for(let i = 0; i < this.dwmRevied.length; i++){
        if(date1 == this.dwmRevied[i]){
          comment = 'Reviewed by employee';
          break;
        }
      }
      for(let i = 0; i < this.getSkipDateList.length; i++){
        if(date1 == this.getSkipDateList[i]){
          comment = 'The Day is Skipped';
          break;
        }
      }
      days.push({
        date: new Date(date),
        comment: comment,
        highlighted:highlighted
      });
      date.setDate(date.getDate() + 1);
    }
    return days;
  }
  // getWeeks(days: any, startDay: any) {
  //   const weeks = [];
  //   let week = [];
  //   for (let i = 0; i < days.length; i++) {
  //     if (days[i].date.getDay() === 0 && week.length > 0) {
  //       weeks.push(week);
  //       week = [];
  //     }
  //     week.push(days[i]);
  //   }
  //   if (week.length > 0) {
  //     weeks.push(week);
  //   }
  //   return weeks;
  // }
  getWeeks(days: any, startDay: any) {
    const weeks = [];
    let week = [];
    
    // Adjust the startDay to match the week starting on Monday
    const adjustedStartDay = (startDay + 6) % 7; // Shift Sunday to the end

    // Fill in the initial empty days for the start of the month
    for (let i = 0; i < adjustedStartDay; i++) {
        week.push(null); // Assuming null means no day in that slot
    }
    
    for (let i = 0; i < days.length; i++) {
        week.push(days[i]);
        // If it's the end of the week, push the week to weeks and reset it
        if ((i + adjustedStartDay + 1) % 7 === 0) {
            weeks.push(week);
            week = [];
        }
    }
    
    // If there are remaining days in the last week, push them as well
    if (week.length > 0) {
        weeks.push(week);
    }

    return weeks;
}
getSkipDateList:any=[];
  getSkippedDays(){
    this.skipedData = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": [this.employeeId],
      "fromDate": this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(this.endDate,'yyyy-MM-dd')
    };
    this.httpService.callPostService(this.config.displayDwmSkipDate, request).subscribe((data: any) => {
      this.getSkipDateList=[];    
      this.skipedData = data?.data?.setResponse;
     data?.data?.setResponse?.forEach((ele:any)=>{
      if(ele.skipDate!=null){
        this.getSkipDateList.push(ele.skipDate)
      }
      })
    })
  }
  getDWMReviewed(){
    this.dwmRevied = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": [this.employeeId],
      "fromDate": this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
    };
    this.httpService.callPostService(this.config.getReviewDate, request).subscribe((data: any) => {
      this.dwmRevied = data?.data;
      this.getSelectedMonth();
    })
  }
  getDWMToBeReviewed(){

  }
  exportDashboardListExcel(){
    if(this.popupName == 'No. of days in the period') {

    }else if (this.popupName == 'No. of Days Skipped') {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.employeeId],
        "fromDate": this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getDwmSkipDaysPdf, request).subscribe((data: any) => {
        saveAs(data?.data, "skipedDays.pdf");
      });
    }else if (this.popupName == 'Days of DWM Reviewed') {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.employeeId],
        "fromDate": this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getReviewDatePdf, request).subscribe((data: any) => {
        saveAs(data?.data, "ReviewedDate.pdf");
      });
    }else if (this.popupName == 'DWM to be reviewed') {

    }
  }
}
